let authenticationURI = 'http://localhost:5100/api';
let baseURI = 'http://localhost:5100/api';
let mockURI =
    'https://c5bbe812-5571-401f-90ad-3c4a6e4f4387.mock.pstmn.io/api/nv';
let siteURI = 'http://localhost:3500';
let betaURI = 'http://localhost:3600';
let nextURI = 'http://localhost:3000';
let deliveryHubURI = 'http://localhost:3030';
let customerFrontURI = 'http://localhost:3501';
let customerFrontURI2 = 'http://localhost:3900';
let customerFrontShort = 'http://localhost:3900';
let publicURI = 'http://localhost:5001/api';
let internalAppURI = 'http://localhost:5001/api';
let cookieName = 'hds-dashboard-beta';
let cookieDomain = undefined;
let s3ImageBase = 'https://images.homedelivery.com.au';
let resizerImageBase = 'https://resize.images.homedelivery.com.au';
let allowEmployeeSSO = true;
let HEREKey;

if (process.env.REACT_APP_AUTH_URI) {
    authenticationURI = process.env.REACT_APP_AUTH_URI;
}
if (process.env.REACT_APP_BASE_URI) {
    baseURI = process.env.REACT_APP_BASE_URI;
}
if (process.env.REACT_APP_CUSTOMER_FRONT_URI) {
    customerFrontURI = process.env.REACT_APP_CUSTOMER_FRONT_URI;
}
if (process.env.REACT_APP_CUSTOMER_FRONT_URI2) {
    customerFrontURI2 = process.env.REACT_APP_CUSTOMER_FRONT_URI2;
}
if (process.env.REACT_APP_CUSTOMER_FRONT_SHORT) {
    customerFrontShort = process.env.REACT_APP_CUSTOMER_FRONT_SHORT;
}
if (process.env.REACT_APP_COOKIE_NAME) {
    cookieName = process.env.REACT_APP_COOKIE_NAME;
}
if (process.env.REACT_APP_COOKIE_DOMAIN) {
    cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;
}
if (process.env.REACT_APP_S3_PATH) {
    s3ImageBase = process.env.REACT_APP_S3_PATH;
}
if (process.env.REACT_APP_URI) {
    siteURI = process.env.REACT_APP_URI;
}

if (process.env.REACT_APP_NEXT_URI && process.env.NODE_ENV !== 'development') {
    nextURI = process.env.REACT_APP_NEXT_URI;
}

if (
    process.env.REACT_APP_DELIVERY_HUB_URI &&
    process.env.NODE_ENV !== 'development'
) {
    deliveryHubURI = process.env.REACT_APP_DELIVERY_HUB_URI;
}

if (process.env.REACT_APP_BETA_URI) {
    betaURI = process.env.REACT_APP_BETA_URI;
}

if (process.env.REACT_APP_PUBLIC_URI) {
    publicURI = process.env.REACT_APP_PUBLIC_URI;
}

if (process.env.REACT_APP_INTERNAL_APP_URI) {
    internalAppURI = process.env.REACT_APP_INTERNAL_APP_URI;
}

if (process.env.REACT_APP_ALLOW_EMPLOYEE_SSO) {
    allowEmployeeSSO = process.env.REACT_APP_ALLOW_EMPLOYEE_SSO == 'true';
}

if (process.env.NEXT_PUBLIC_HERE_TOKEN) {
    HEREKey = process.env.NEXT_PUBLIC_HERE_TOKEN;
}

let env = 'prod';
if (baseURI.includes('.mask.')) {
    env = 'mask';
}
if (baseURI.includes('.sandbox.')) {
    env = 'sandbox';
}

export default {
    cookieName: cookieName,
    cookieDomain: cookieDomain,
    authenticationURI: authenticationURI,
    baseURI: baseURI,
    mockURI: mockURI,
    betaURI: betaURI,
    nextURI: nextURI,
    deliveryHubURI: deliveryHubURI,
    siteURI: siteURI,
    publicURI: publicURI,
    internalAppURI: internalAppURI,
    customerFrontURI: customerFrontURI,
    customerFrontURI2: customerFrontURI2,
    customerFrontShort: customerFrontShort,
    googleMapsKey: 'AIzaSyAL4VkJVgs3VGGJ9YfS1TolRNUTt0LT1Lc',
    HEREAppId: '9hJLdCNhjRsHN073eK49',
    HEREKey,
    s3ImageBase: s3ImageBase,
    resizerImageBase: resizerImageBase,
    imageBase: '',
    bannerBase: 'banners',
    mapProvider: 'here',
    allowEmployeeSSO: allowEmployeeSSO,
    env: env,
};
